import { components, InputProps, GroupBase } from 'react-select'

import styles from './Input.module.scss'

export const Input = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: InputProps<Option, IsMulti, Group>
) => <components.Input {...props} className={styles.root} />
